
const data = [
    {
        "question": "假日最想？",
        "backgroundImage": "/images/background-2.png",
        "leftImage": "/images/page1-left.png",
        "rightImage": "/images/page1-right.png",
        "leftImageWidth": 193,
        "leftImageHeight": 290,
        "rightImageWidth": 250,
        "rightImageHeight": 237,

        "answer-backgroundColor": "#E99F2E",
        "answer-color": "#2A5E1D",
        "answer-border": "0px",

        "answer":[
            {
                "text": "宅在家看劇",
                "dimetion": [0, 0]
            },
            {
                "text": "出門找刺激",
                "dimetion": [0, 1]
            }
        ]
    },
    {
        "question": "說到你最愛的話題時？",
        "backgroundImage": "/images/background-3.png",
        "leftImage": "/images/page2-left.png",
        "rightImage": "/images/page2-right.png",
        "leftImageWidth": 211,
        "leftImageHeight": 317,
        "rightImageWidth": 261,
        "rightImageHeight": 261,

        "answer-backgroundColor": "#FEC14F",
        "answer-color": "#2C783A",
        "answer-border": "0px",

        "answer":[
            {
                "text": "慢慢講，挑時機",
                "dimetion": [0, 0]
            },
            {
                "text": "直接開講，管他在哪",
                "dimetion": [0, 1]
            }
        ]
    },
    {
        "question": "路上遇到熟人？",
        "backgroundImage": "/images/background-1.png",
        "leftImage": "/images/page3-left.png",
        "rightImage": "/images/page3-right.png",
        "leftImageWidth": 185,
        "leftImageHeight": 252,
        "rightImageWidth": 259,
        "rightImageHeight": 232,

        "answer-backgroundColor": "#4A794C",
        "answer-color": "#FFFFFF",
        "answer-border": "0px",

        "answer":[
            {
                "text": "快閃假裝沒看到",
                "dimetion": [0, 0]
            },
            {
                "text": "主動打招呼，順便聊兩句",
                "dimetion": [0, 1]
            }
        ]
    },
    {
        "question": "接收新資訊時？",
        "backgroundImage": "/images/background-3.png",
        "leftImage": "/images/page4-left.png",
        "rightImage": "/images/page4-right.png",
        "leftImageWidth": 239,
        "leftImageHeight": 344,
        "rightImageWidth": 189,
        "rightImageHeight": 284,

        "answer-backgroundColor": "#FEC14F",
        "answer-color": "#23661A",
        "answer-border": "0px",

        "answer":[
            {
                "text": "喜歡先知道「怎麼用」",
                "dimetion": [1, 0]
            },
            {
                "text": "喜歡先知道「為什麼」",
                "dimetion": [1, 1]
            }
        ]
    },
    {
        "question": "看到未來科技趨勢新聞？",
        "backgroundImage": "/images/background-2.png",
        "leftImage": "/images/page5-left.png",
        "rightImage": "/images/page5-right.png",
        "leftImageWidth": 204,
        "leftImageHeight": 343,
        "rightImageWidth": 210,
        "rightImageHeight": 344,

        "answer-backgroundColor": "#E99F2E",
        "answer-color": "#2A7B4B",
        "answer-border": "0px",

        "answer":[
            {
                "text": "不如來點現實的優惠比較實在",
                "dimetion": [1, 0]
            },
            {
                "text": "超有想像空間，未來會怎樣啊",
                "dimetion": [1, 1]
            }
        ]
    },
    {
        "question": "計畫旅遊時？",
        "backgroundImage": "/images/background-3.png",
        "leftImage": "/images/page6-left.png",
        "rightImage": "/images/page6-right.png",
        "leftImageWidth": 242,
        "leftImageHeight": 339,
        "rightImageWidth": 299,
        "rightImageHeight": 339,

        "answer-backgroundColor": "#FEC14F",
        "answer-color": "#207443",
        "answer-border": "0px",

        "answer":[
            {
                "text": "地圖路線先查好",
                "dimetion": [1, 0]
            },
            {
                "text": "想到再走就好，過程比較重要",
                "dimetion": [1, 1]
            }
        ]
    },
    {
        "question": "處理朋友問題時？",
        "backgroundImage": "/images/background-1.png",
        "leftImage": "/images/page7-left.png",
        "rightImage": "/images/page7-right.png",
        "leftImageWidth": 210,
        "leftImageHeight": 315,
        "rightImageWidth": 194,
        "rightImageHeight": 291,

        "answer-backgroundColor": "#4A794C",
        "answer-color": "#FFFFFF",
        "answer-border": "0px",

        "answer":[
            {
                "text": "以感受為先的人",
                "dimetion": [2, 0]
            },
            {
                "text": "分析怎麼解決的人",
                "dimetion": [2, 1]
            }
        ]
    },
    {
        "question": "聽到朋友曲解你時？",
        "backgroundImage": "/images/background-1.png",
        "leftImage": "/images/page8-left.png",
        "rightImage": "/images/page8-right.png",
        "leftImageWidth": 227,
        "leftImageHeight": 341,
        "rightImageWidth": 205,
        "rightImageHeight": 274,

        "answer-backgroundColor": "#4A794C",
        "answer-color": "#FFFFFF",
        "answer-border": "0px",

        "answer":[
            {
                "text": "先顧他的感受再慢慢解釋",
                "dimetion": [2, 0]
            },
            {
                "text": "把來龍去脈一次講清楚",
                "dimetion": [2, 1]
            }
        ]
    },
    {
        "question": "幫朋友選禮物？",
        "backgroundImage": "/images/background-2.png",
        "leftImage": "/images/page9-left.png",
        "rightImage": "/images/page9-right.png",
        "leftImageWidth": 269,
        "leftImageHeight": 269,
        "rightImageWidth": 232,
        "rightImageHeight": 348,

        "answer-backgroundColor": "#E99F2E",
        "answer-color": "#298344",
        "answer-border": "0px",

        "answer":[
            {
                "text": "他收到會不會開心？",
                "dimetion": [2, 0]
            },
            {
                "text": "好用實用才是重點",
                "dimetion": [2, 1]
            }
        ]
    },
    {
        "question": "遇到新計畫？",
        "backgroundImage": "/images/background-2.png",
        "leftImage": "/images/page10-left.png",
        "rightImage": "/images/page10-right.png",
        "leftImageWidth": 237,
        "leftImageHeight": 355,
        "rightImageWidth": 236,
        "rightImageHeight": 355,

        "answer-backgroundColor": "#E99F21",
        "answer-color": "#2D6B1D",
        "answer-border": "0px",

        "answer":[
            {
                "text": "計畫好再動",
                "dimetion": [3, 0]
            },
            {
                "text": "邊做邊想",
                "dimetion": [3, 1]
            }
        ]
    },
    {
        "question": "要出門聚會時？",
        "backgroundImage": "/images/background-3.png",
        "leftImage": "/images/page11-left.png",
        "rightImage": "/images/page11-right.png",
        "leftImageWidth": 219,
        "leftImageHeight": 329,
        "rightImageWidth": 214,
        "rightImageHeight": 321,

        "answer-backgroundColor": "#FEC14F",
        "answer-color": "#2E8C31",
        "answer-border": "0px",

        "answer":[
            {
                "text": "前一天衣服、交通都想好",
                "dimetion": [3, 0]
            },
            {
                "text": "快到門口才決定穿什麼",
                "dimetion": [3, 1]
            }
        ]
    },
    {
        "question": "行程臨時改變時？",
        "backgroundImage": "/images/background-1.png",
        "leftImage": "/images/page12-left.png",
        "rightImage": "/images/page12-right.png",
        "leftImageWidth": 175,
        "leftImageHeight": 262,
        "rightImageWidth": 254,
        "rightImageHeight": 254,

        "answer-backgroundColor": "#4A794C",
        "answer-color": "#FFFFFF",
        "answer-border": "0px",

        "answer":[
            {
                "text": "會有點焦慮、想馬上重排",
                "dimetion": [3, 0]
            },
            {
                "text": "無所謂，順流就好",
                "dimetion": [3, 1]
            }
        ]
    }

]

export default data;